// src/components/ConfirmModal.js
import React, { useEffect, useRef } from "react";

export default function ConfirmModal({ 
  title, 
  message, 
  confirmText = "Confirm", 
  cancelText = "Cancel", 
  confirmVariant = "danger", // "danger", "primary", "warning"
  onConfirm, 
  onClose 
}) {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const getConfirmButtonClass = () => {
    switch (confirmVariant) {
      case "danger":
        return "btn-delete";
      case "warning":
        return "btn-warning";
      default:
        return "btn-primary";
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal confirm-modal" ref={modalRef} style={{ maxWidth: "450px" }}>
        <h3>{title || "Confirm Action"}</h3>
        <p style={{ marginBottom: "24px", fontSize: "14px", color: "#475569" }}>
          {message}
        </p>
        <div className="modal-actions" style={{ justifyContent: "center", gap: "12px" }}>
          <button className="btn-secondary" onClick={onClose}>
            {cancelText}
          </button>
          <button 
            className={getConfirmButtonClass()} 
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}